import React from "react";

import AppHeader from "~/components/AppHeader";

const LoginHeader = props => {
  return <AppHeader back={true} />;
};

export default LoginHeader;
